import React, { useEffect } from 'react';
import { 
    Grid,
   } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useAuth } from './Auth'
import WallpaperAir from './images/WALLPAPER.png'
const useStyles = makeStyles({
    paper:{
        backgroundImage: `url(${WallpaperAir})`,
        backgroundRepeat:'no-repeat',
        backgroundSize:'cover',
        height:'97vh',
    },
    root:{
        padding:0
    }
});

function Inicio (){
    const classes = useStyles();
    const { setIsInLogin } = useAuth();

    useEffect(() => {
        setIsInLogin(false);
    }, []); // eslint-disable-line react-hooks/exhaustive-deps 
    
    return(
        <Grid container className={classes.root}>
            <Grid item xl={12} lg={12} md={12} sm={12} xs={12} className={classes.paper}>   
            </Grid>
        </Grid>
        
    );
};

export default Inicio;